import { Menu as AntMenu } from "antd";

export const Menu = AntMenu;
